interface BubbleButtonProps {
  text: string;
  onClick: () => void;
}

const BubbleButton: React.FC<BubbleButtonProps> = ({ onClick, text }) => {
  return (
    <button
      onClick={onClick}
      className={
        'text-base m-1.5 px-2 py-1 bg-opacity-10 bg-white rounded-xl outline-none ' +
        'hover:bg-opacity-0 ' +
        'transition-all'
      }>{text}</button>
  );
}

export default BubbleButton;
